export default {
    setDemandsLoading   : (state, loading) => (state.loading = loading),
    setDemandsFormSaving: (state, saving) => (state.saving = saving),
    appendDemand        : (state, demand) => (state.demands.push(demand)),
    setDemands          : (state, demands) => (state.demands = demands),
    deleteDemandByIndex : (state, index) => (state.demands.splice(index, 1))
};
